import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent || '');
const MOD = isMac ? '⌘' : 'Ctrl';

// #150 — a discoverable list of the shortcuts this session actually implements.
// Deliberately doesn't list aspirational bindings (J/K list nav, E edit, ⌘S
// save, ⌘Z undo) that aren't wired up yet — a cheatsheet that lies about what
// works is worse than a short, honest one.
const SHORTCUTS = [
  [`${MOD}+K`, 'Open the command palette (jump to an item, or run a command)'],
  ['/', 'Focus the search box'],
  ['?', 'Show this cheatsheet'],
  ['Esc', 'Close the palette / cheatsheet / an open dialog'],
];

export default function ShortcutsCheatsheet({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth data-testid="shortcuts-cheatsheet">
      <DialogTitle>Keyboard shortcuts</DialogTitle>
      <DialogContent>
        <Table size="small">
          <TableBody>
            {SHORTCUTS.map(([keys, desc]) => (
              <TableRow key={keys}>
                <TableCell sx={{ whiteSpace: 'nowrap' }}><span className="kbd">{keys}</span></TableCell>
                <TableCell>{desc}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
}
